import { useTranslation } from 'react-i18next'
import { KebabCase } from 'type-fest'

import { SectionTab } from 'components/Tabs'
import { Domain } from 'features/inventory/types/domain'
import { Workspace } from 'features/workspace'
import { useAbility } from 'providers/casl'
import { ProductTab } from 'types/productTab'
import { KWordsForm } from './sections/KWordsForm/Form'
import { MultiAnchorForm } from './sections/MultiAnchorForm'

export type RichPlacementsUrlParams = Partial<{
  id: Domain['id']
  section: SectionRouteParam
  tab: ProductTab
  workspaceId: Workspace['id']
}>

export type SectionRouteParam = KebabCase<'k-words' | 'multi-anchor'>

export const useSectionTabs = (): SectionTab<SectionRouteParam>[] => {
  const ability = useAbility()
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'defaults.richPlacements.sections',
  })

  const noAccessToMultiAnchor = ability.cannot('access', 'DomainRichPlacementsTab-multiAnchor')

  return [
    {
      disabled: noAccessToMultiAnchor,
      element: 'multi-anchor',
      label: t('multiAnchor'),
      page: noAccessToMultiAnchor ? <></> : <MultiAnchorForm />,
    },
    {
      element: 'k-words',
      label: t('kWords'),
      page: <KWordsForm />,
    },
  ]
}
